import React, { HTMLAttributes } from 'react';

import {
  Container,
  WysiwygField,
} from '@uncinc/uncinc-react-kitchen-sink';
import { DynamicMediaItem } from '@uncinc/react-drupal-core';
import type { ImmutableEntity } from '@uncinc/react-drupal-core/types';

import { ReactComponent as QuoteIcon } from '../../../assets/images/icons/custom/format_quote.svg';
import { ParagraphQuote as Type } from '../../../types/uncinc_profile/paragraphs';

import './style.scss';

interface ParagraphQuoteProps extends React.HTMLProps<HTMLAttributes<HTMLDivElement>> {
  entity: ImmutableEntity<Type>;
}

const ParagraphQuote: React.FC<ParagraphQuoteProps> = ({
  entity,
}) => {
  const paragraphQuote = entity.toJS();

  const writer = paragraphQuote.field_name[0]?.value;
  const quote = paragraphQuote.field_body[0]?.value;
  const maxChars = 500;
  const position = paragraphQuote.field_label[0]?.value;
  const imageStyles = paragraphQuote.field_media_item[0];

  return (
    <div className="Paragraph ParagraphQuote">
      <Container>
        <div className="ParagraphQuote row">

          {imageStyles && (
            <div className="left col-12 col-md-5">
              <div className="ParagraphQuote__image">
                <DynamicMediaItem
                  media={imageStyles}
                  imageAspectRatio="3_4"
                />
              </div>
            </div>
          )}

          <div className="gutterBackground" />

          <div className={`right col-12 ${imageStyles ? 'col-md-7' : ''}`}>
            <div className="ParagraphQuote__content">
              <QuoteIcon className="ParagraphQuote__icon" />
              <WysiwygField max_chars={maxChars} html={quote} />
              <div className="ParagraphQuote__quoted">
                {writer && <p className="ParagraphQuote__writer">{writer}</p>}
                {position && <span>{position}</span>}
              </div>
            </div>
          </div>

        </div>
      </Container>
    </div>
  );
};

export default ParagraphQuote;
